class SubscriptionPaymentDetailsEnterCard implements ng.IComponentController {
    constructor() {
    }
}

angular.module('animatronApp.SubscriptionPaymentDetailsEnterCard', [])
    .component('subscriptionPaymentDetailsEnterCard', {
        controller: SubscriptionPaymentDetailsEnterCard,
        templateUrl: require('settings/subscription/payment-details/subscription-payment-details-enter-card.html')
    });



// WEBPACK FOOTER //
// ./app/assets/javascripts/settings/subscription/payment-details/SubscriptionPaymentDetailsEnterCard.ts